import React from 'react';
import { useNavigate } from "react-router-dom";
import {Box, Grid, Button, Link} from '@material-ui/core';
import LoadingButton from '@mui/lab/LoadingButton';
import {TextField, Stack, Snackbar, Alert} from '@mui/material';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "./HeaderMy";
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  
  var vertical='top',horizontal='center';
  
  export default function Execute() {
	const navigate = useNavigate();
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');

	const [filter, setFilter] = React.useState(false);

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
  
	const [newPassword, setNewPassword] = React.useState("");
	const [currentPassword, setCurrentPassword] = React.useState("");
	const [confirmNewPassword, setConfirmNewPassword] = React.useState("");
	const [submitResponse, setSubmitResponse] = React.useState(false);

	
	function hideAlert(){
		setShowAlert(false);
	}

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			navigate('/login');
		}
	}, [isloggedin]);

	function search(){
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}
	

	function submit(){
		if(!currentPassword){
			setShowAlert(true);
			setAlertMessage("Enter your current password.");
			document.getElementById("current-password-inputid").focus();			
			return false;
		}else if(!newPassword){
			setShowAlert(true);
			setAlertMessage("Enter your new password.");
			document.getElementById("new-password-inputid").focus();			
			return false;
		}else if(newPassword && newPassword.length<6){
			setShowAlert(true);
			setAlertMessage("Your password must have lease 6 characters.");
			document.getElementById("new-password-inputid").focus();			
			return false;
		}else if(newPassword===currentPassword){
			setShowAlert(true);
			setAlertMessage("New password must not be same as current password.");
			document.getElementById("new-password-inputid").focus();			
			return false;	
		}else if(!confirmNewPassword){
			setShowAlert(true);
			setAlertMessage("Enter your confirm new password.");
			document.getElementById("confirm-new-password-inputid").focus();			
			return false;
		}else if(newPassword!==confirmNewPassword){
			setShowAlert(true);
			setAlertMessage("Your confirm password does not match with new password.");
			document.getElementById("confirm-new-password-inputid").focus();			
			return false;
		}else{
			document.getElementById('waitloginbtnid').style.display='';
			document.getElementById('loginbtnid').style.display='none';
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
				}
			};		  
			const data = new FormData(); 
			data.append('currentPassword', currentPassword);
			data.append('password', newPassword);			
			axios.post(API_URL+'/crm-change-password-crmusers', data, axiosHeader)
			.then((response) => {
				///console.log("RESPONSE RECEIVED: ", response);
				if(response && response.data && response.data.responseTxt==="success"){					
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setSubmitResponse(true);
				}else if(response.data.responseTxt==="currentPasswordInvalid"){
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage("Your current password is invalid.");			
					return false;
				}else if(response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');
				}else{
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage("Error somewhere, Try after sometime.");			
					return false;
				}
			})
			.catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(" "+error);			
				return false;
			})
		}  
	}
	


	return (
		<div> 
				<MetaTags>
            		<title>Change Password</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Change Password" />

				<Box className='mainBox'>	

				<Box>
						<Grid container style={{justifyContent: 'center'}} spacing={2}>
							<Grid item className="dhslogin" md={6} xs={12}>

								<Grid className="flex-container" >								
									
									<Grid md={12} xs={12} mt={5} >
										{submitResponse?<span style={{color:'#0158dc',fontSize:16,fontWeight:'bold',lineHeight:2}}>Your password has been changed successfully.<br/><Link href="dashboard" className="loginfrgot" >Go to Dashboard</Link></span>:
										<>
										<TextField
											onKeyPress={(event)=>{onEnter(event)}}
											onChange={event => setCurrentPassword(event.target.value)}
											value={currentPassword}
											color="primary"
											id="current-password-inputid"
											label="Current Password"
											fullWidth	
											variant="filled"
											type="password"
											sx={{backgroundColor:'#FFF',borderRadius: 2}}								
										/>
										<TextField
											onKeyPress={(event)=>{onEnter(event)}}
											onChange={event => setNewPassword(event.target.value)}
											value={newPassword}
											color="primary"
											id="new-password-inputid"
											label="New Password"
											fullWidth	
											variant="filled"
											type="password"
											sx={{marginTop:2, backgroundColor:'#FFF',borderRadius: 2}}								
										/>
										<TextField
											onKeyPress={(event)=>{onEnter(event)}}
											onChange={event => setConfirmNewPassword(event.target.value)}
											value={confirmNewPassword}
											color="primary"
											id="confirm-new-password-inputid"
											label="Confirm New Password"
											fullWidth	
											variant="filled"
											type="password"
											sx={{marginTop:2, backgroundColor:'#FFF',borderRadius: 2}}								
										/>
										</>
										}
									</Grid>									
									{!submitResponse?
									<Grid style={{marginTop:10}} md={12} xs={12}>
										<Button id="loginbtnid" onClick={()=>{submit()}} className="loginbtn" variant="contained">SUBMIT</Button>
										<LoadingButton 
											className="loginbtn"
											loading
											loadingPosition="start"											
											variant="outlined"
											color="secondary"
											id="waitloginbtnid" 
											style={{textTransform: 'none',display:'none'}}
										>
											Wait...
										</LoadingButton>
									</Grid>
									:null}
								
								</Grid>
							</Grid>
						</Grid>
				</Box>


				</Box>


			<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
			</Stack>



		</div>	
	);
  }